module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/327.71d09e0a.png";